var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", [
    _vm.forChar > 0
      ? _c(
          "label",
          {
            staticClass: "personalisation-overlay-details--label",
            attrs: { for: "for-personalisation-input" },
          },
          [_vm._v("for")]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-input" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.forInput,
            expression: "forInput",
          },
        ],
        ref: "forInput",
        staticClass: "sensitive",
        attrs: {
          disabled: _vm.adding,
          id: "for-personalisation-input",
          placeholder: "for",
          maxlength: _vm.forCharMax,
          type: "text",
        },
        domProps: { value: _vm.forInput },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.forInput = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "span",
        { class: _vm.forChar > _vm.forCharMax ? "count-over" : "count" },
        [_vm._v(_vm._s(_vm.forChar) + "/" + _vm._s(_vm.forCharMax))]
      ),
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        _c(
          "button",
          {
            class:
              _vm.adding || _vm.forChar === 0
                ? "preview-button--disabled"
                : "preview-button",
            staticStyle: { width: "100%" },
            on: { click: _vm.addToCart },
          },
          [_vm._v("Add to cart")]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }